import Vue from "vue";
import Vuex from "vuex";
import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    baseURL: "https://mixa-api.tamdabuyazilim.com",
    companyUrl: "https://tamdabuguvenlik.com",
    companyName: "Mixa Enroll",
    version: "1.0.49",
    user: {
      id: 0,
      userName: "",
      mail: "",
      title: "",
      profileUrl: "",
      companyName: "",
      token: "",
      defaultVisitorCardGroup: 0,
      language: "",
      authType: 0
    },
    requiredFields: [],
    authMap: {
      canliIzleme: 2,
      kisiler: 2,
      gecisYetkileri: 2,
      raporlar: 2,
      ayarlar: 2,
      tanimlamalar: 2,
      ziyaretciTakip: 2,
      yemekhane: 2,
      dashboard: 2,
      creditSale: 2,
      bekciTur: 2,
      shiftYonetimi: 2,
      puantajYonetimi: 2,
      shiftYetkileri: {
        canPlan: false,
        canConfirmShift: false,
        canConfirmAllowence: false,
        canPlanAllowence: false,
        canSeeRealMovements: false,
        sendMailWhenUnconfirmedShifts: false,
        sendWarningMailOnSecondDay: false
      }
    },
    defaultFilters: {
      nameOrCardNumber: "",
      sicilOrTerminalNo: null,
      departments: [],
      accessGroup: [],
      identityNo: "",
      documentNoOrMail: "",
      foodGroup: [],
      workGroupId: [],
      title: "",
      stateId: [],
      statuId: [],
      plateNo: "",
      extraField1key: 0,
      extraField1value: "",
      extraField2key: 0,
      extraField2value: "",
      extraField3key: 0,
      extraField3value: "",
      extraField4key: 0,
      extraField4value: "",
      isVisitor: false,
      isActive: true
    },
    buildings: [
      {
        target: "bank.png",
        tags: "bank, banka, bina",
        name: "Bank"
      },
      {
        target: "building.png",
        tags: "building, bina, ofis, office",
        name: "Building"
      },
      {
        target: "building-2.png",
        tags: "building, bina, ofis, office",
        name: "Building-2"
      },
      {
        target: "building-3.png",
        tags: "building, bina, ofis, office",
        name: "Building-3"
      },
      {
        target: "building-4.png",
        tags: "building, bina, ofis, office",
        name: "Building-4"
      },
      {
        target: "building-5.png",
        tags: "building, bina, ofis, office",
        name: "Building-5"
      },
      {
        target: "building-6.png",
        tags: "building, bina, ofis, office",
        name: "Building-6"
      },
      {
        target: "building-7.png",
        tags: "building, bina, ofis, office",
        name: "Building-7"
      },
      {
        target: "building-8.png",
        tags: "building, bina, ofis, office",
        name: "Building-8"
      },
      {
        target: "building-9.png",
        tags: "building, bina, ofis, office",
        name: "Building-9"
      },
      {
        target: "building-10.png",
        tags: "building, bina, ofis, office",
        name: "Building-10"
      },
      {
        target: "building-11.png",
        tags: "building, bina, ofis, office",
        name: "Building-11"
      },
      {
        target: "building-12.png",
        tags: "building, bina, ofis, office",
        name: "Building-12"
      },
      {
        target: "building-13.png",
        tags: "building, bina, ofis, office",
        name: "Building-13"
      },
      {
        target: "building-14.png",
        tags: "building, bina, ofis, office",
        name: "Building-14"
      },
      {
        target: "building-15.png",
        tags: "building, bina, ofis, office",
        name: "Building-15"
      },
      {
        target: "building-16.png",
        tags: "building, bina, ofis, office",
        name: "Building-16"
      },
      {
        target: "building-17.png",
        tags: "building, bina, ofis, office",
        name: "Building-17"
      },
      {
        target: "building-18.png",
        tags: "building, bina, ofis, office",
        name: "Building-18"
      },
      {
        target: "building-19.png",
        tags: "building, bina, ofis, office",
        name: "Building-19"
      },
      {
        target: "building-20.png",
        tags: "building, bina, ofis, office",
        name: "Building-20"
      },
      {
        target: "building-21.png",
        tags: "building, bina, ofis, office",
        name: "Building-21"
      },
      {
        target: "building-22.png",
        tags: "building, bina, ofis, office",
        name: "Building-22"
      },
      {
        target: "building-23.png",
        tags: "building, bina, ofis, office",
        name: "Building-23"
      },
      {
        target: "building-24.png",
        tags: "building, bina, ofis, office",
        name: "Building-24"
      },
      {
        target: "building-25.png",
        tags: "building, bina, ofis, office",
        name: "Building-25"
      },
      {
        target: "building-26.png",
        tags: "building, bina, ofis, office",
        name: "Building-26"
      },
      {
        target: "building-27.png",
        tags: "building, bina, ofis, office",
        name: "Building-27"
      },
      {
        target: "building-28.png",
        tags: "building, bina, ofis, office",
        name: "Building-28"
      },
      {
        target: "building-29.png",
        tags: "building, bina, ofis, office",
        name: "Building-29"
      },
      {
        target: "building-30.png",
        tags: "building, bina, ofis, office",
        name: "Building-30"
      },
      {
        target: "building-31.png",
        tags: "building, bina, ofis, office",
        name: "Building-31"
      },
      {
        target: "building-32.png",
        tags: "building, bina, ofis, office",
        name: "Building-32"
      },
      {
        target: "building-33.png",
        tags: "building, bina, ofis, office",
        name: "Building-33"
      },
      {
        target: "building-34.png",
        tags: "building, bina, ofis, office",
        name: "Building-34"
      },
      {
        target: "building-35.png",
        tags: "building, bina, ofis, office",
        name: "Building-35"
      },
      {
        target: "building-36.png",
        tags: "building, bina, ofis, office",
        name: "Building-36"
      },
      {
        target: "cafe.png",
        tags: "cafe, kafe, restoran, restaurant",
        name: "Cafe"
      },
      {
        target: "education.png",
        tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
        name: "Education"
      },
      {
        target: "education-2.png",
        tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
        name: "Education-2"
      },
      {
        target: "education-3.png",
        tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
        name: "Education-3"
      },
      {
        target: "factory.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory"
      },
      {
        target: "factory-2.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-2"
      },
      {
        target: "factory-3.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-3"
      },
      {
        target: "factory-4.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-4"
      },
      {
        target: "factory-5.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-5"
      },
      {
        target: "factory-6.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-6"
      },
      {
        target: "factory-7.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-7"
      },
      {
        target: "factory-8.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-8"
      },
      {
        target: "factory-9.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-9"
      },
      {
        target: "factory-10.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-10"
      },
      {
        target: "factory-11.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-11"
      },
      {
        target: "factory-12.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-12"
      },
      {
        target: "factory-13.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-13"
      },
      {
        target: "factory-14.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-14"
      },
      {
        target: "factory-15.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-15"
      },
      {
        target: "factory-16.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-16"
      },
      {
        target: "factory-17.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-17"
      },
      {
        target: "factory-18.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-18"
      },
      {
        target: "factory-19.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-19"
      },
      {
        target: "factory-20.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-20"
      },
      {
        target: "factory-21.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-21"
      },
      {
        target: "factory-22.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-22"
      },
      {
        target: "factory-23.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-23"
      },
      {
        target: "factory-24.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-24"
      },
      {
        target: "factory-25.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-25"
      },
      {
        target: "factory-26.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-26"
      },
      {
        target: "factory-27.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-27"
      },
      {
        target: "factory-28.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-28"
      },
      {
        target: "factory-29.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-29"
      },
      {
        target: "factory-30.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-30"
      },
      {
        target: "factory-31.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-31"
      },
      {
        target: "factory-32.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-32"
      },
      {
        target: "factory-33.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-33"
      },
      {
        target: "factory-34.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-34"
      },
      {
        target: "factory-35.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-35"
      },
      {
        target: "factory-36.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-36"
      },
      {
        target: "factory-37.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-37"
      },
      {
        target: "factory-38.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-38"
      },
      {
        target: "factory-39.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-39"
      },
      {
        target: "factory-40.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-40"
      },
      {
        target: "factory-41.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-41"
      },
      {
        target: "factory-42.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-42"
      },
      {
        target: "factory-43.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-43"
      },
      {
        target: "factory-44.png",
        tags: "factory, endustries, endüstri, fabrika, sanayi",
        name: "Factory-44"
      },
      {
        target: "fire-station.png",
        tags: "fire, station, itfaiye, yangın",
        name: "Fire Station"
      },
      {
        target: "gas-station.png",
        tags: "gas, station, benzinlik, oto",
        name: "Gas Station"
      },
      {
        target: "hospital.png",
        tags: "hospital, hastane, yatakhane",
        name: "Hospital"
      },
      {
        target: "hospital-2.png",
        tags: "hospital, hastane, yatakhane",
        name: "Hospital-2"
      },
      {
        target: "hospital-3.png",
        tags: "hospital, hastane, yatakhane",
        name: "Hospital-3"
      },
      {
        target: "hotel.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel"
      },
      {
        target: "hotel-2.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-2"
      },
      {
        target: "hotel-3.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-3"
      },
      {
        target: "hotel-4.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-4"
      },
      {
        target: "hotel-5.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-5"
      },
      {
        target: "hotel-6.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-6"
      },
      {
        target: "hotel-7.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-7"
      },
      {
        target: "hotel-8.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-8"
      },
      {
        target: "hotel-9.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-9"
      },
      {
        target: "hotel-10.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-10"
      },
      {
        target: "hotel-11.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-11"
      },
      {
        target: "hotel-12.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-12"
      },
      {
        target: "hotel-13.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-13"
      },
      {
        target: "hotel-14.png",
        tags: "hotel, otel, pansiyon, inn",
        name: "Hotel-14"
      },
      {
        target: "house.png",
        tags: "house, ev, home, müstakil",
        name: "House"
      },
      {
        target: "house-2.png",
        tags: "house, ev, home, müstakil",
        name: "House-2"
      },
      {
        target: "house-3.png",
        tags: "house, ev, home, müstakil",
        name: "House-3"
      },
      {
        target: "house-4.png",
        tags: "house, ev, home, müstakil",
        name: "House-4"
      },
      {
        target: "house-5.png",
        tags: "house, ev, home, müstakil",
        name: "House-5"
      },
      {
        target: "house-6.png",
        tags: "house, ev, home, müstakil",
        name: "House-6"
      },
      {
        target: "house-7.png",
        tags: "house, ev, home, müstakil",
        name: "House-7"
      },
      {
        target: "house-8.png",
        tags: "house, ev, home, müstakil",
        name: "House-8"
      },
      {
        target: "house-9.png",
        tags: "house, ev, home, müstakil",
        name: "House-9"
      },
      {
        target: "house-10.png",
        tags: "house, ev, home, müstakil",
        name: "House-10"
      },
      {
        target: "house-11.png",
        tags: "house, ev, home, müstakil",
        name: "House-11"
      },
      {
        target: "house-12.png",
        tags: "house, ev, home, müstakil",
        name: "House-12"
      },
      {
        target: "museum.png",
        tags: "museum, müze",
        name: "Museum"
      },
      {
        target: "office-building.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building"
      },
      {
        target: "office-building-2.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-2"
      },
      {
        target: "office-building-3.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-3"
      },
      {
        target: "office-building-4.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-4"
      },
      {
        target: "office-building-5.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-5"
      },
      {
        target: "office-building-6.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-6"
      },
      {
        target: "office-building-7.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-7"
      },
      {
        target: "office-building-8.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-8"
      },
      {
        target: "office-building-9.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-9"
      },
      {
        target: "office-building-10.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-10"
      },
      {
        target: "office-building-11.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-11"
      },
      {
        target: "office-building-12.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-12"
      },
      {
        target: "office-building-13.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-13"
      },
      {
        target: "office-building-14.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-14"
      },
      {
        target: "office-building-15.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-15"
      },
      {
        target: "office-building-16.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-16"
      },
      {
        target: "office-building-17.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-17"
      },
      {
        target: "office-building-18.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-18"
      },
      {
        target: "office-building-19.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-19"
      },
      {
        target: "office-building-20.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-20"
      },
      {
        target: "office-building-21.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-21"
      },
      {
        target: "office-building-22.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-22"
      },
      {
        target: "office-building-23.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-23"
      },
      {
        target: "office-building-24.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-24"
      },
      {
        target: "office-building-25.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-25"
      },
      {
        target: "office-building-26.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-26"
      },
      {
        target: "office-building-27.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-27"
      },
      {
        target: "office-building-28.png",
        tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
        name: "Office Building-28"
      },
      {
        target: "police-department.png",
        tags: "polis, police, cop, karakol, station, police station, emniyet",
        name: "Police Department"
      },
      {
        target: "police-department-2.png",
        tags: "polis, police, cop, karakol, station, police station, emniyet",
        name: "Police Department-2"
      },
      {
        target: "pool.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool"
      },
      {
        target: "pool-2.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-2"
      },
      {
        target: "pool-3.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-3"
      },
      {
        target: "pool-4.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-4"
      },
      {
        target: "pool-5.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-5"
      },
      {
        target: "pool-6.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-6"
      },
      {
        target: "pool-7.png",
        tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
        name: "Pool-7"
      },
      {
        target: "ship.png",
        tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
        name: "Ship"
      },
      {
        target: "ship-2.png",
        tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
        name: "Ship-2"
      },
      {
        target: "ship-3.png",
        tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
        name: "Ship-3"
      },
      {
        target: "ship-4.png",
        tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
        name: "Ship-4"
      },
      {
        target: "ship-5.png",
        tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
        name: "Ship-5"
      },
      {
        target: "sport.png",
        tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, basketball",
        name: "Sport"
      },
      {
        target: "sport-2.png",
        tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, football, university, high school",
        name: "Sport-2"
      },
      {
        target: "sport-3.png",
        tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, football",
        name: "Sport-3"
      },
      {
        target: "store.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store"
      },
      {
        target: "store-2.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-2"
      },
      {
        target: "store-3.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-3"
      },
      {
        target: "store-4.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-4"
      },
      {
        target: "store-5.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-5"
      },
      {
        target: "store-6.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-6"
      },
      {
        target: "store-7.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-7"
      },
      {
        target: "store-8.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-8"
      },
      {
        target: "store-9.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-9"
      },
      {
        target: "store-10.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-10"
      },
      {
        target: "store-11.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-11"
      },
      {
        target: "store-12.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-12"
      },
      {
        target: "store-13.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-13"
      },
      {
        target: "store-14.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-14"
      },
      {
        target: "store-15.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-15"
      },
      {
        target: "store-16.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-16"
      },
      {
        target: "store-17.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-17"
      },
      {
        target: "store-18.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-18"
      },
      {
        target: "store-19.png",
        tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
        name: "Store-19"
      },
      {
        target: "tv-station.png",
        tags: "tv, television, televizyon, vizontele, tv station, tv kanalı, kanal",
        name: "TV Station"
      },
    ],
    modules: {
      visitor: false, //ZİYARETÇİ
      visitorTemporaryCard: false, //ZİYARETÇİ GEÇİCİ KART
      visitorAccessGroups: false, //ZİYARETÇİ ERİŞİM GRUPLARI
      dormitory: false, //YURT
      diningHall: false, //YEMEKHANE
      foodMenuPopup: false, //YEMEK MENÜSÜ EKRANI
      retailSale: false, //HIZLI SATIŞ, BAKİYE DÜŞME EKRANI
      memberManagement: false, //ÜYE TAKİP
      licencePlateRecognition: false, //PLAKA TANIMA SİSTEMİ
      hgs: false, //HGS
      plate: false, //PLAKA
      annualPermit: false, //YILLIK İZİN
      saveMovementLog: false, //YENİ HAREKET OLUŞTURMA
      payroll: false, //PUANTAJ
      payrollManagement: false, //PUANTAJ YÖNETİMİ
      timezone: false, //TİMEZONE
      smsOrMail: false, //SMS VE MAİL SİSTEMİ
      student: false, //ÖĞRENCİ
      sms: false, //SMS AKTİF Mİ
      guardTour: false, //BEKÇİ TUR
      scenario: false, //ÖZEL SENARYO
      integration: false,
      shiftManagement: false, //Shift modülünü açar
      dashboardBirthdays: false, //Dashboard'ta doğum günü kutlama modülünü açar
      customFieldName: "Belge No",
      maxTerminalCount: 40,
      maxMobileUsers: 1000,
      mobileApp: false, //Mobil uygulama özelliğini açar
      allowenceRequests: false, //İzin talepleri özelliğini açar
      controlPanelStatistics: false, //Kontrol panelinde istatistikleri açar
      isDisabledTerminalNo: true //Kişilerdeki 'Terminal No' alanını elle girilemez hale getirir
    },
  },
  mutations,
  getters,
  actions,
  modules: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js